export default "__VITE_ASSET__DGOx14vz__"